'use strict';

var _ = require('lodash');
var StrategyConditionFactory = function StrategyConditionFactory($filter, momentService, strategyConditionDataService, StrategyConstants) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var rmPercent = $filter('rmPercent');
  function StrategyCondition(params) {
    this.category = params.category || '';
    this.metaCategory = params.metaCategory || '';
    this.criterion = params.criterion || '';
    this.operator = params.operator || '';
    this.precision = params.precision || 0;
    this.field = params.field || '';
    this.formula = params.formula || '';
    this.appendices = params.appendices || {
      urdFunctionType: ''
    };
    this.isFieldValueRequired = !_.isUndefined(params.isFieldValueRequired) ? params.isFieldValueRequired : true;
    if (params.leftOperand === 0) {
      this.leftOperand = params.leftOperand;
      this.formattedLeftOperand = params.leftOperand;
    } else {
      this.leftOperand = params.leftOperand || '';
      this.formattedLeftOperand = params.leftOperand ? formatValue(params.leftOperand, params.fieldType, params.field) : '';
    }
    this.rightOperand = params.rightOperand || '';
    this.formattedRightOperand = params.rightOperand ? formatValue(params.rightOperand, params.fieldType) : '';
    this.quantifier = params.quantifier || 'AND';
  }
  function formatEntities(values, field) {
    return _.reduce(values, function (formattedValues, value) {
      var entityData = _.find(strategyConditionDataService.getOperandData(field), ['value', value]);
      if (_.has(entityData, 'dropdownVisibleValue')) {
        formattedValues.push(entityData.dropdownVisibleValue);
      } else {
        formattedValues.push(value);
      }
      return formattedValues;
    }, []).join(', ');
  }
  function formatValue(value, fieldType, field) {
    if (field === 'leg.entity' || field === 'marketDemand.entity') {
      return formatEntities(value, field);
    }
    if (momentService.isMoment(value)) {
      var momentFormat = value.isTime() ? 'TIME_USER_SETTINGS' : 'DATE_USER_SETTINGS';
      return rmMomentFormat(value, momentFormat);
    }
    if (_.isObject(value) && _.has(value, 'dropdownVisibleValue')) {
      return value.dropdownVisibleValue;
    }
    if (_.isArray(value)) {
      return value.join(', ');
    }
    if (fieldType === 'percent' || fieldType === '2percent') {
      return rmPercent(value);
    }
    return value;
  }
  StrategyCondition.prototype.isEqual = function (obj) {
    return _.isEqual(this.category, obj.category) && _.isEqual(this.criterion, obj.criterion) && _.isEqual(this.leftOperand, obj.leftOperand) && _.isEqual(this.operator, obj.operator) && _.isEqual(this.rightOperand, obj.rightOperand) && _.isEqual(this.field, obj.field) && _.isEqual(this.quantifier, obj.quantifier);
  };
  function isLeftOperandEmpty(operand, isFieldValueRequired) {
    return (operand === '' || operand === null) && isFieldValueRequired || operand === undefined;
  }
  function isRightOperandEmpty(operator, operand) {
    return operator.indexOf('Between') !== -1 && (operand === '' || operand === null || operand === undefined);
  }
  StrategyCondition.prototype.isEmpty = function () {
    return _.isEmpty(this.category) && _.isEmpty(this.criterion) && _.isEmpty(this.operator) && _.isEmpty(this.field) && (isLeftOperandEmpty(this.leftOperand, this.isFieldValueRequired) || isRightOperandEmpty(this.operator, this.rightOperand));
  };
  StrategyCondition.prototype.isValid = function () {
    return !this.isEmpty() && !this.isValueEmpty();
  };
  StrategyCondition.prototype.isValueEmpty = function () {
    return this.field === '' || this.field === null || this.field === undefined || isLeftOperandEmpty(this.leftOperand, this.isFieldValueRequired) || isRightOperandEmpty(this.operator, this.rightOperand);
  };
  StrategyCondition.prototype.toString = function () {
    return [this.quantifier, this.category, this.criterion, this.operator, this.leftOperand, this.rightOperand].join(' ') + (this.appendices.urdFunctionType ? ' ' + this.appendices.urdFunctionType : '');
  };
  StrategyCondition.prototype.isOperandDataQuantityOverThreshold = function () {
    return _.isArray(this.leftOperand) && this.leftOperand.length > StrategyConstants.MAX_SELECTABLE_OPERANDS_DATA;
  };
  StrategyCondition.prototype.createCopy = function () {
    return new StrategyCondition(this);
  };
  return StrategyCondition;
};
StrategyConditionFactory.$inject = ['$filter', 'MomentService', 'StrategyConditionDataService', 'StrategyConstants'];
module.exports = StrategyConditionFactory;